export default __webpack_public_path__ + "static/media/miscellaneous24.44c1c5e6.png";